import type { Font } from '@pdfme/common'

const SARABUN_REGULAR_URL = '/fonts/Sarabun-Regular.ttf'
const SARABUN_BOLD_URL = '/fonts/Sarabun-Bold.ttf'

let cachedFont: ArrayBuffer | null = null
let fontFaceRegistered = false

// Register Sarabun with document.fonts via the FontFace API. The browser
// fetches the URL itself and skips the CSS-processing path that emits
// the "(invalid URI)" / "maxp: Bad maxZones: 0" warning in Firefox when
// pdfme injects its own @font-face for the editor canvas.
function ensureFontFaceRegistered(): void {
  if (fontFaceRegistered || typeof document === 'undefined') return
  fontFaceRegistered = true
  try {
    const regular = new FontFace('Sarabun', `url(${SARABUN_REGULAR_URL})`, {
      style: 'normal',
      weight: '400',
      display: 'swap',
    })
    const bold = new FontFace('Sarabun', `url(${SARABUN_BOLD_URL})`, {
      style: 'normal',
      weight: '700',
      display: 'swap',
    })
    regular.load().then((f) => document.fonts.add(f)).catch(() => {})
    bold.load().then((f) => document.fonts.add(f)).catch(() => {})
  } catch {
    // FontFace API unsupported — silent fallback.
  }
}

export async function loadThaiFont(): Promise<ArrayBuffer> {
  ensureFontFaceRegistered()
  if (cachedFont) return cachedFont
  const res = await fetch(SARABUN_REGULAR_URL)
  if (!res.ok) throw new Error(`Failed to load font: ${res.status}`)
  cachedFont = await res.arrayBuffer()
  return cachedFont
}

export async function getThaiFontConfig(): Promise<Font> {
  const data = await loadThaiFont()
  return {
    Sarabun: {
      data,
      fallback: true,
    },
  }
}

export function getThaiFontConfigSync(data: ArrayBuffer): Font {
  return {
    Sarabun: {
      data,
      fallback: true,
    },
  }
}
